export const DEFAULT_STAGE_SETTINGS = ({
  x: 0,
  y: 0,
  scale: 1,
  rotation: 0
} as const);
export const STAGE_EVENTS = ({
  POINTER_DOWN: 'pointerdown',
  POINTER_UP: 'pointerup',
  POINTER_MOVE: 'pointermove',
  POINTER_ENTER: 'pointerenter',
  POINTER_LEAVE: 'pointerleave',
  DRAG_START: 'dragstart',
  DRAG: 'drag',
  DRAG_END: 'dragend',
  DOUBLE_CLICK: 'doubleclick',
  RIGHT_CLICK: 'contextmenu'
} as const);
export const DRAG_STATE = ({
  DRAG_START: 'DRAG_START',
  DRAG: 'DRAG',
  DRAG_END: 'DRAG_END'
} as const);
export const CSS_VARS = ({
  SCALE: '--stage-scale',
  ROTATION: '--stage-rotation',
  VISIBLE_SCALE: '--stage-visible-scale',
  INVERSE_SCALE_1X: '--stage-inverse-scale-1x',
  INVERSE_SCALE_1_5X: '--stage-inverse-scale-1-5x'
} as const);